const KEY = "whatisinside.scanhistory.v1";
const MAX = 10;

export const readHistory = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const addHistory = (entry) => {
  const list = readHistory().filter((h) => h.barcode !== entry.barcode);
  list.unshift({ ...entry, scannedAt: new Date().toISOString() });
  const next = list.slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {}
  return next;
};

export const clearHistory = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {}
  return [];
};
